import { html } from 'lit-html';
import { RecentCheckedItemJsEnv } from '../../../models/recent_checked_item/recent_checked_item_js_env';
import { RecentCheckedItemArea } from './recent_checked_item';

// prettierの自動整形をしたくない場合だけ付与する
// prettier-ignore
export const RecentCheckedItemBody = (model: RecentCheckedItemJsEnv) => html`
${RecentCheckedItemArea(model)}
`;
